import { ProductAttributeValueType } from 'API';
import { Fragment } from 'react';
import { LocalAttributeAggregate } from 'types/order-entry';
import { AggregateAttributeTypeEnum } from './AggregateAttributeTypeEnum';

const AggregateAttributeTypeOther: React.FC<Omit<LocalAttributeAggregate, 'attributeValueType'>> = () => null;

const components: Record<
  ProductAttributeValueType,
  React.FunctionComponent<Omit<LocalAttributeAggregate, 'attributeValueType'>>
> = {
  [ProductAttributeValueType.Enum]: AggregateAttributeTypeEnum,
  [ProductAttributeValueType.String]: AggregateAttributeTypeOther, // TODO: not implemented yet (not needed for now)
  [ProductAttributeValueType.Bool]: AggregateAttributeTypeOther, // TODO: not implemented yet (not needed for now)
  [ProductAttributeValueType.Number]: AggregateAttributeTypeOther, // TODO: not implemented yet (not needed for now)
  [ProductAttributeValueType.ToothSelection]: AggregateAttributeTypeOther, // TODO: not implemented yet (not needed for now)
  [ProductAttributeValueType.Diagram]: AggregateAttributeTypeOther, // TODO: not implemented yet (not needed for now)
  [ProductAttributeValueType.Radio]: AggregateAttributeTypeOther, // TODO: not implemented yet (not needed for now)
};

export type AttributeAggregateDynamicItemProps = LocalAttributeAggregate & {
  onValueChange?: (currentValue: string, previousValue: string) => void;
};

export const AttributeAggregateDynamicItem: React.FC<AttributeAggregateDynamicItemProps> = ({
  attributeValueType,
  ...restProps
}) => {
  const Component = attributeValueType ? components[attributeValueType] : Fragment;
  return <Component {...restProps} />;
};
